import CompanyListPage from "@/pages/business-management"
import CompanyDetailsPage from "@/pages/business-management/company-details"
import PromotionReportPage from "@/pages/business-management/promotion-report"

export const companyList = {
  path: 'business-management/company-list',
  component: CompanyListPage
}

export const companyDetail = {
  path: 'business-management/company-details',
  component: CompanyDetailsPage
}

export const promotionReport = {
  path: 'business-management/promotion-report',
  component: PromotionReportPage
}


// WEBPACK FOOTER //
// ./src/router/business-management.js